/** One add intent, one write, and its accepted cart rendering share one barrier. */
(function () {
  if (window.CartAdd) return;

  function controllerForCart() {
    const surface = document.querySelector('[data-cart-drawer], [data-cart-page]');
    const items = surface?.querySelector('[data-cart-items]');
    if (!items || !window.CartLineControls || !window.CartOperations) return null;
    return { surface, controller: new window.CartLineControls(items) };
  }

  function errorFor(message, code) {
    const error = new Error(message);
    error.code = code;
    return error;
  }

  function add(url, payload, trigger) {
    // Freeze the purchase at the click, before it can wait behind another write.
    const intent = JSON.parse(JSON.stringify(payload));
    const cart = controllerForCart();
    if (!cart) return Promise.reject(errorFor('Cart controls are not ready.', 'not-ready'));
    return window.CartOperations.run(async (operation) => {
      let refreshAttempted = false;
      let confirmed = false;
      document.dispatchEvent(new CustomEvent('cart:changing'));
      try {
        const data = await operation.requestJSON(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(intent),
        });
        if (!data || !Array.isArray(data.items) || !data.items.length
          || data.items.some((item) => !item || !Number(item.id) || !(Number(item.quantity) > 0))) {
          operation.markUncertain();
          throw errorFor('The cart response could not be verified.', 'payload');
        }
        confirmed = true;
        refreshAttempted = true;
        await cart.controller.refreshWithinOperation(operation, cart.surface);
        if (!operation.isCurrent()) throw errorFor('The cart response is no longer current.', 'stale');
        const detail = { trigger, cartRefreshed: true };
        // The drawer consumes this flag; it must not queue a second refresh
        // behind the very add operation that is awaiting its rendering.
        document.dispatchEvent(new CustomEvent('cart:add', { detail }));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail }));
        return data;
      } catch (error) {
        // 422 can still apply a partial add. Read/render once, never replay the
        // payload and never subtract a guessed quantity as compensation.
        if (!refreshAttempted) {
          refreshAttempted = true;
          try {
            await cart.controller.refreshWithinOperation(operation, cart.surface);
          } catch {
            operation.markUncertain();
          }
        }
        // A confirmed write with broken rendering is not a failed add that can
        // be safely sent again. Keep purchase actions blocked until recovery.
        if (confirmed) operation.markUncertain();
        throw error;
      }
    }, { mutation: true });
  }

  function showRecovery(status) {
    if (!status || !window.CartOperations?.isBlocked()) return false;
    const english = document.documentElement.lang?.toLowerCase().startsWith('en');
    status.hidden = false;
    status.setAttribute('role', 'alert');
    status.setAttribute('aria-live', 'assertive');
    status.textContent = window.CartMessages?.uncertain || (english
      ? 'It is unclear whether the change was applied. Check your cart and reload this page before making further changes.'
      : 'Ob die Änderung übernommen wurde, ist unklar. Prüfen Sie Ihren Warenkorb und laden Sie diese Seite vor weiteren Änderungen neu.');
    const reload = document.createElement('a');
    reload.href = window.location.href;
    reload.textContent = window.CartMessages?.reload || (english ? 'Reload page' : 'Seite neu laden');
    status.append(' ', reload);
    return true;
  }

  window.CartAdd = { add, showRecovery };
})();
